import { useState } from "react";
import { C } from "./const";
import { SERVICES } from "./IntroServices";
import SectionBadge from "./IntroSectionBadge";
import SectionTitle from "./IntroSectionTitle";

const IntroContactForm = () => {
    const [form, setForm] = useState({
        name: "",
        phone: "",
        type: "",
        message: "",
    });
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
    ) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setSubmitted(true);
    };

    return (
        <section id="contact" style={{ background: C.neutralLight, padding: "80px 24px" }}>
            <div style={{ maxWidth: 1200, margin: "0 auto" }}>
                <div style={{ textAlign: "center", marginBottom: 52 }}>
                    <SectionBadge text="تماس با ما" />
                    <SectionTitle center>با ما در تماس باشید</SectionTitle>
                    <p style={{ color: C.gray, fontSize: 16, maxWidth: 520, margin: "0 auto", lineHeight: 1.8 }}>
                        فرم زیر را پر کنید تا کارشناسان ما در اسرع وقت با شما تماس بگیرند
                    </p>
                </div>

                <div
                    className="grid-2"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 48,
                        alignItems: "start",
                    }}
                >
                    {/* Contact info */}
                    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                        {[
                            { icon: "📞", title: "تلفن مستقیم", value: "۰۲۱-۸۸۸۰۸۳۶۴", sub: "شنبه تا پنجشنبه ۸ تا ۱۸" },
                            { icon: "📱", title: "تلفن همراه", value: "۰۹۳۷-۸۵۶-۱۸۰۲", sub: "پاسخگویی ۲۴ ساعته" },
                            { icon: "📷", title: "اینستاگرام", value: "parsian_503987", sub: "پاسخگویی ۲۴ ساعته" },
                            { icon: "📧", title: "ایمیل", value: "parsianinsurance503987@gmail.com", sub: "پاسخ در کمتر از ۲ ساعت" },
                            { icon: "📍", title: "آدرس دفتر", value: "تهران، خیابان ولیعصر", sub: "تقاطع چهارراه طالقانی،مجتمع تجاری نور تهران،واحد ۱۱۱۲۴" },
                        ].map((item) => (
                            <div
                                key={item.title}
                                style={{
                                    display: "flex",
                                    gap: 16,
                                    alignItems: "flex-start",
                                    background: C.white,
                                    borderRadius: 14,
                                    padding: "18px 20px",
                                    border: `1px solid ${C.border}`,
                                    boxShadow: "0 2px 12px rgba(0,86,179,.05)",
                                }}
                            >
                                <div
                                    style={{
                                        width: 48,
                                        height: 48,
                                        background: C.primaryLight,
                                        borderRadius: 12,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: 22,
                                        flexShrink: 0,
                                    }}
                                >
                                    {item.icon}
                                </div>
                                <div>
                                    <div style={{ fontWeight: 700, color: C.primaryDark, fontSize: 14, marginBottom: 3 }}>
                                        {item.title}
                                    </div>
                                    <div style={{ color: C.primary, fontWeight: 600, fontSize: 15, marginBottom: 2 }}>
                                        {item.value}
                                    </div>
                                    <div style={{ color: C.grayLight, fontSize: 12 }}>{item.sub}</div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Form */}
                    <div
                        style={{
                            background: C.white,
                            borderRadius: 20,
                            padding: 36,
                            boxShadow: "0 8px 32px rgba(0,86,179,.1)",
                            border: `1px solid ${C.border}`,
                        }}
                    >
                        {submitted ? (
                            <div style={{ textAlign: "center", padding: "40px 0" }}>
                                <div style={{ fontSize: 64, marginBottom: 18 }}>✅</div>
                                <h3 style={{ color: C.primaryDark, fontSize: 20, fontWeight: 800, marginBottom: 10 }}>
                                    پیام شما ارسال شد!
                                </h3>
                                <p style={{ color: C.gray, fontSize: 14, lineHeight: 1.8 }}>
                                    کارشناسان ما به زودی با شما تماس خواهند گرفت.
                                </p>
                                <button
                                    onClick={() => { setSubmitted(false); setForm({ name: "", phone: "", type: "", message: "" }); }}
                                    style={{
                                        marginTop: 24,
                                        background: C.primary,
                                        color: C.white,
                                        border: "none",
                                        padding: "11px 28px",
                                        borderRadius: 10,
                                        fontWeight: 700,
                                        fontSize: 14,
                                        cursor: "pointer",
                                    }}
                                >
                                    ارسال پیام جدید
                                </button>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 18 }}>
                                <h3 style={{ color: C.primaryDark, fontSize: 18, fontWeight: 800, marginBottom: 6 }}>
                                    درخواست مشاوره رایگان
                                </h3>

                                {/* Name & Phone */}
                                <div className="grid-2" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
                                    {[
                                        { name: "name", placeholder: "نام و نام خانوادگی", type: "text" },
                                        { name: "phone", placeholder: "شماره تماس", type: "tel" },
                                    ].map((f) => (
                                        <input
                                            key={f.name}
                                            name={f.name}
                                            type={f.type}
                                            placeholder={f.placeholder}
                                            value={(form as any)[f.name]}
                                            onChange={handleChange}
                                            required
                                            style={{
                                                padding: "12px 14px",
                                                borderRadius: 10,
                                                border: `1.5px solid ${C.border}`,
                                                fontSize: 14,
                                                        outline: "none",
                                                color: C.neutral,
                                                background: C.neutralLight,
                                                width: "100%",
                                            }}
                                        />
                                    ))}
                                </div>

                                {/* Insurance type */}
                                <select
                                    name="type"
                                    value={form.type}
                                    onChange={handleChange}
                                    required
                                    style={{
                                        padding: "12px 14px",
                                        borderRadius: 10,
                                        border: `1.5px solid ${C.border}`,
                                        fontSize: 14,
                                        outline: "none",
                                        color: form.type ? C.neutral : C.grayLight,
                                        background: C.neutralLight,
                                        cursor: "pointer",
                                    }}
                                >
                                    <option value="" disabled>نوع بیمه مورد نظر را انتخاب کنید</option>
                                    {SERVICES.map((s) => (
                                        <option key={s.title} value={s.title}>{s.title}</option>
                                    ))}
                                </select>

                                {/* Message */}
                                <textarea
                                    name="message"
                                    placeholder="توضیحات بیشتر (اختیاری)"
                                    value={form.message}
                                    onChange={handleChange}
                                    rows={4}
                                    style={{
                                        padding: "12px 14px",
                                        borderRadius: 10,
                                        border: `1.5px solid ${C.border}`,
                                        fontSize: 14,
                                        outline: "none",
                                        color: C.neutral,
                                        background: C.neutralLight,
                                        resize: "vertical",
                                    }}
                                />

                                <button
                                    type="submit"
                                    className="hov-btn"
                                    style={{
                                        background: `linear-gradient(135deg, ${C.primary}, ${C.primaryDark})`,
                                        color: C.white,
                                        border: "none",
                                        padding: "14px",
                                        borderRadius: 10,
                                        fontWeight: 800,
                                        fontSize: 16,
                                        cursor: "pointer",
                                    }}
                                >
                                    ارسال درخواست مشاوره
                                </button>

                                <p style={{ color: C.grayLight, fontSize: 12, textAlign: "center" }}>
                                    🔒 اطلاعات شما کاملاً محرمانه نزد ما باقی می‌ماند
                                </p>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </section>

    );
}
export default IntroContactForm;